export const pdfUrlCheck = (url, children) => {

    let linkProps = {href: url}

    if (url && url.match(/\.pdf$/)) {

        // fallback for PDF title based on text of link
        let title = ''
        if (typeof children === 'string' || children instanceof String){
            title = `&title=${children}`
        }
    
        linkProps.href = `/pdfViewer?pdf=${url}${title}`
        linkProps.target = "_blank";
        linkProps.pdf = true;
    }

    return linkProps
}